import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { RootState } from '../../store/store.state';
import { selectCurrentPageState } from '../store/navigation.selectors';
import { NavBarLinks } from '../store/navigation.state';
import { NavigationDetails } from 'quotient-ng-core';

@Component({
    selector: 'q-sub-navbar',
    templateUrl: './sub-navbar.component.html',
    styleUrls: ['./sub-navbar.component.scss']
})
export class SubNavbarComponent implements OnInit {
    currentPage$: Observable<string>;
    private navPaths: object = {
        [NavBarLinks.ALL_EVENTS]: '/events/list',
        [NavBarLinks.CREATE_EVENT]: '/events/create',
        [NavBarLinks.UPLOAD_EVENTS]: '/upload/create',
        [NavBarLinks.UPLOAD_HISTORY]: '/upload/history',
        [NavBarLinks.RETAILER_DASHBOARD]: '/redirect-rd'
    };

    selectedNavPage: MerchandisingNavigationDetails;

    homePage: MerchandisingNavigationDetails = {
        path: this.navPaths[NavBarLinks.ALL_EVENTS],
        name: NavBarLinks.ALL_EVENTS
    };

    navigationList: MerchandisingNavigationDetails[] = [
        this.homePage,
        {
            path: this.navPaths[NavBarLinks.CREATE_EVENT],
            name: NavBarLinks.CREATE_EVENT
        },
        {
            path: this.navPaths[NavBarLinks.UPLOAD_EVENTS],
            name: NavBarLinks.UPLOAD_EVENTS
        },
        {
            path: this.navPaths[NavBarLinks.UPLOAD_HISTORY],
            name: NavBarLinks.UPLOAD_HISTORY
        },
        {
            path: this.navPaths[NavBarLinks.RETAILER_DASHBOARD],
            name: NavBarLinks.RETAILER_DASHBOARD,
            skipLocationChange: true
        }
    ];

    constructor(private store: Store<RootState>) {
        this.currentPage$ = store.pipe(select(selectCurrentPageState));
    }

    ngOnInit() {
        /* NgRx Router => Subscribe to change in navigation URL. Mainly needed for navigation done outside the main navigation 
           dropdown, for ex. Event Details page. This gives mapping of page header text for corresponding redirected URL. */
        this.currentPage$.subscribe(currentPage => {
            this.selectedNavPage = this.externalNavigation(currentPage);
        });
    }

    /**
     * Called to indicate an external navigation has occurred, i.e. not from main nav dropdown.
     * @param currentUrl String value of the page to be navigated to.
     */
    externalNavigation(currentUrl: string) {
        let currentPageName: NavBarLinks;
        switch (currentUrl) {
            case this.navPaths[NavBarLinks.ALL_EVENTS]: {
                currentPageName = NavBarLinks.ALL_EVENTS;
                break;
            }
            case this.navPaths[NavBarLinks.CREATE_EVENT]: {
                currentPageName = NavBarLinks.CREATE_EVENT;
                break;
            }
            case this.navPaths[NavBarLinks.UPLOAD_EVENTS]: {
                currentPageName = NavBarLinks.UPLOAD_EVENTS;
                break;
            }
            case this.navPaths[NavBarLinks.UPLOAD_HISTORY]: {
                currentPageName = NavBarLinks.UPLOAD_HISTORY;
                break;
            }
            default: {
                /* Default case for "Event Details" & "Event Clone" */
                currentPageName = currentUrl.startsWith('/events/clone/')
                    ? NavBarLinks.EVENT_CLONE
                    : NavBarLinks.EVENT_DETAILS;
            }
        }
        return {
            name: currentPageName,
            path: currentUrl
        };
    }
}

interface MerchandisingNavigationDetails extends NavigationDetails {
    path: string;
    name: NavBarLinks;
}
